module.exports = __webpack_public_path__ + "media/img/vca/vca-e3ed84e7a356a6cf954e8e860a4e8f61.png";